export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function modifyTitle(data, titleValidator) {
    const { Title: text } = data.items[0];
    const tag = titleValidator ? 'h1' : 'h2';
    const heading = `<${tag} class="card-widget-title" aria-label="${text}">${text}</${tag}>`;
    $widgetHTML.find('span.card-widget-title').replaceWith(heading);
  }

  function createCustomSeo() {
    const $item = $widgetHTML.find('.card-widget-item').detach();
    $widgetHTML.find('.square-deco-content').append($item);
    $item.find('.moreButton').addClass('button');
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const titleIsH1 = !!$('#vimeoWidget').length;
      if (hasData) {
        modifyTitle(data, titleIsH1);
        createCustomSeo();
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'LEARN MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
